import React from 'react';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import api from '../../services/axios';
import RenderBrowserRouter from './RenderBrowserRouter';

const AuthenticatedUser = (props) => {

  const { t, i18n } = useTranslation();
  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  // I initialize the user language with the value read from the auth api
  useEffect(() => {
    changeLanguage(props.loginParameters.language);
  }, [props.loginParameters.language])

  const logout = async (e) => {
    e.preventDefault();
    let error = null;
    try {
      const response = await api.get('/react_logout', {
        headers: {
          'Authorization': `Bearer ${props.loginParameters.accesToken}`
        }
      });
      if (response.data) {
        error = 0;
      }
    } catch (err) {
      error = 1;
    }
    window.localStorage.setItem(
      'loggedNewIntranetAppUser', ''
    )
    // Provoco el refresco de la página para que cargue el login
    window.location.reload();
  }

  return (

    <RenderBrowserRouter
      loginParameters={props.loginParameters}
      t={t}
      i18n={i18n}
      changeLanguage={changeLanguage}
      logout={logout}
    >
    </RenderBrowserRouter>
  );
};

export default AuthenticatedUser;